/**
 * Identity of the current welcome-banner campaign.
 *
 * Bump `version` in a future release to re-show the banner to everyone —
 * including users who dismissed an earlier version.
 * A user's dismissal is stored as `welcomeBannerDismissedVersion` inside
 * their persisted dashboard config and only suppresses campaigns with a
 * version <= the stamped one.
 */
export const WELCOME_BANNER_CAMPAIGN = { version: 1 } as const;

export const WELCOME_BANNER_TYPE = 'welcomeBanner';
